import React from 'react';
import Promo from '../Main/Promo/Promo';
import HowItWorks from '../Main/HowItWorks/HowitWorks';

function Main() {
  return (
    <main>
      <Promo />
      <HowItWorks />
    </main>
  );
}

export default Main;

// import React from 'react';
// import Promo from '../Main/Promo/Promo';

// function Main() {
//   return (
//     <main>
//       <Promo />
//     </main>
//   );
// }

// export default Main;
